export function getCookieMap() {
    return document.cookie.split(';').reduce((acc, cookieString) => {
        const [key, value] = cookieString.split('=').map((s) => s.trim());
        if (key && value) {
            acc[key] = decodeURIComponent(value);
        }
        return acc;
    }, {});
}
export function getCookie(name) {
    const cookies = getCookieMap();
    return cookies[name] || '';
}
export function setCookie(name, value, options = {}) {
    const optionsSerialized = Object.keys(options).reduce((acc, key) => {
        return acc + `;${key.replace(/([A-Z])/g, ($1) => '-' + $1.toLowerCase())}=${options[key]}`;
    }, '');
    document.cookie = `${name}=${encodeURIComponent(value)}${optionsSerialized}`;
}
export function deleteCookie(name, options = {}) {
    setCookie(name, '', { ...options, expires: -1 });
}
